export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN"
export const SET_AUTH = "SET_AUTH"
export const CLEAR_AUTH = "CLEAR_AUTH"